import { Code } from '@tiptap/extension-code'

export const CodeMark = Code.extend({
  priority: 1001,
  inclusive: true,
  exitable: true,
  excludes: null as any,
  code: true,
  spanning: true,
})
